import { render, staticRenderFns } from "./NavigatorBottomBarLinkCommunityChat.vue?vue&type=template&id=21d9fc59"
import script from "./NavigatorBottomBarLinkCommunityChat.vue?vue&type=script&lang=js"
export * from "./NavigatorBottomBarLinkCommunityChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports